import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import api from "./../../../Api.js";

/**
 * ReviveChallenge — modal que aparece quando HP zera (regra 4).
 * Pega pergunta aleatoria, aluno responde pra reviver.
 */
class ReviveChallenge extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      question: null,
      loading: true,
      answered: false,
      result: null
    };
  }

  async componentDidMount() {
    await this.loadQuestion();
  }

  async loadQuestion() {
    this.setState({ loading: true });
    try {
      var res = await api.getRandomQuestion(this.props.classroom);
      this.setState({ question: res.data, loading: false });
    } catch (e) {
      this.setState({ loading: false });
    }
  }

  async submit(answerIndex) {
    if (this.state.answered) return;
    this.setState({ answered: true });
    try {
      var res = await api.revivePlayer(this.props.userId, this.state.question.id, answerIndex);
      this.setState({ result: res.data });

      if (res.data.success) {
        setTimeout(() => {
          if (this.props.onRevived) this.props.onRevived(res.data);
        }, 2000);
      } else {
        // Resposta errada — tenta outra pergunta após 2s
        setTimeout(() => {
          this.setState({ answered: false, result: null });
          this.loadQuestion();
        }, 2500);
      }
    } catch (e) {
      this.setState({ answered: false });
    }
  }

  render() {
    var q = this.state.question;
    var result = this.state.result;

    return (
      <Modal isOpen={true} backdrop="static" keyboard={false} centered size="lg">
        <ModalHeader>
          <i className="fas fa-skull mr-2" style={{ color: '#dc3545' }} />
          Você foi derrotado! Desafio de Revival
        </ModalHeader>
        <ModalBody>
          {result && result.success && (
            <div className="alert alert-success text-center py-4">
              <i className="fas fa-heart fa-3x mb-2" style={{ color: '#28a745' }} />
              <h3>Revivido!</h3>
              <p>HP restaurado: <strong>{result.hpAfter}</strong></p>
            </div>
          )}
          {result && !result.success && (
            <div className="alert alert-danger text-center py-3">
              <i className="fas fa-times-circle fa-2x mb-2" />
              <p className="mb-0">Resposta errada! Tentando outra pergunta...</p>
            </div>
          )}
          {!result && this.state.loading && (
            <div className="text-center py-4">
              <i className="fas fa-spinner fa-spin fa-2x text-muted" />
            </div>
          )}
          {!result && !this.state.loading && q && (
            <React.Fragment>
              <p style={{ fontSize: '0.9rem', color: '#666' }}>
                Responda corretamente para reviver seu personagem com 50 HP:
              </p>
              <h4 className="mb-4 text-center" style={{ background: '#f8f9fa', padding: '20px', borderRadius: '8px' }}>
                {q.question}
              </h4>
              <div>
                {q.options.map((opt, idx) => (
                  <Button
                    key={idx}
                    color="primary"
                    block
                    size="lg"
                    className="mb-2 text-left"
                    onClick={() => this.submit(idx)}
                    disabled={this.state.answered}
                    style={{ padding: '15px 20px' }}
                  >
                    <strong>{String.fromCharCode(65 + idx)})</strong> {opt}
                  </Button>
                ))}
              </div>
            </React.Fragment>
          )}
          {!result && !this.state.loading && !q && (
            <div className="text-center py-4 text-muted">
              <p>Nenhuma pergunta disponível. Procure o professor.</p>
            </div>
          )}
        </ModalBody>
      </Modal>
    );
  }
}

export default ReviveChallenge;
